export default function SvgChevronRight(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg {...props} viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 9L4.29289 5.70711C4.68342 5.31658 4.68342 4.68342 4.29289 4.29289L1 1" stroke="currentColor" strokeWidth="2" />
        </svg>
    );
}
